export type IProduct = {
  id: string;
  code: string;
  name: string;
  image?: string;
  sku?: string;
  gender?: string;
  description?: string;
  category?: string;
  type?: string;
  currentStock?: number | string;
  salePrice?: number | string;
  purchasePrice?: number | string;
  discountPercentage?: number | string;
  vatRate?: number;
  productDetails?: {
    model?: string;
    color?: string;
    material?: string;
    size?: string;
    modality?: string;
    frameType?: string;
  };
  brandId?: number;
  brand?: { id?: number; name?: string };
  status?: string;
  isActive?: boolean;
  createdAt?: Date;
  createdDate?: Date;
  price?: number;
  quantity?: number;
  supplierId?: number;
  supplier?: { id?: number; name?: string };
  requiresLotTracking?: boolean;
  packSize?: number;
};

export type IProductRequest = {};

export enum ProductStatus {
  DRAFT = "draft",
  PUBLISH = "published",
  UNPUBLISH = "unpublished",
}

export enum ProductType {
  FRAMES = 'frames',
  LENSES = 'lenses',
  CONTACT_LENSES = 'contact_lenses',
  SUNGLASSES = 'sunglasses',
  ACCESSORIES = 'accessories',
  SUNDRIES = 'sundries',
  SOLUTION = 'solution',
}

export enum ProductCategory {
  // Frame categories
  PRESCRIPTION_FRAMES = 'prescription_frames',
  READING_GLASSES = 'reading_glasses',
  SAFETY_GLASSES = 'safety_glasses',

  // Lens categories
  SINGLE_VISION = 'single_vision',
  BIFOCAL = 'bifocal',
  PROGRESSIVE = 'progressive',

  // Contact lens categories
  DAILY_DISPOSABLE = 'daily_disposable',
  WEEKLY_DISPOSABLE = 'weekly_disposable',
  MONTHLY_DISPOSABLE = 'monthly_disposable',
  COLORED_CONTACTS = 'colored_contacts',

  // Sunglasses categories
  PRESCRIPTION_SUNGLASSES = 'prescription_sunglasses',
  POLARIZED_SUNGLASSES = 'polarized_sunglasses',
  PHOTOCHROMIC_SUNGLASSES = 'photochromic_sunglasses',

  // Accessory categories
  CASES = 'cases',
  CLEANING_SOLUTIONS = 'cleaning_solutions',
  STRAPS = 'straps',
  REPAIR_KITS = 'repair_kits',

  // Sundries categories
  CONSUMABLES = 'consumables',
  CLOTHS_AND_WIPES = 'cloths_and_wipes',
  BATTERIES = 'batteries',

  // Solution categories
  SALINE_SOLUTION = 'saline_solution',
  MULTIPURPOSE_SOLUTION = 'multipurpose_solution',
  HYDROGEN_PEROXIDE_SOLUTION = 'hydrogen_peroxide_solution',
}
